import {GetHeaderV2Response_SubBrands} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {
  Button,
  COLORS,
  GenericIconName,
  HorizontalList,
  HorizontalListWrapper,
  Icon,
  Z_INDEXES,
  mobileOnlyLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useTilesSlider} from '../../utils/useTilesSlider';
import {BrandPageSubBrandsList} from './BrandPageSubBrandsList';

const SLIDER_GAP = 8;

export const BrandPageSubBrands: React.FC<{
  subBrands: GetHeaderV2Response_SubBrands;
}> = ({subBrands}) => {
  const {scrollWrapperRef, next, prev, isNextActive, isPrevActive} =
    useTilesSlider();

  return (
    <Wrapper data-testid="BrandLogoSlider">
      {isPrevActive && (
        <PrevCircleButton
          onClick={() => prev()}
          aria-label={undefined}
          size="sm"
        >
          <Icon
            size="XSS"
            asset={GenericIconName.ArrowLeft}
            fill={COLORS.White}
          />
        </PrevCircleButton>
      )}
      <StyledHorizontalList
        data-testid="SliderContainer"
        ref={scrollWrapperRef}
        $centered={subBrands.subBrands.length < 3}
      >
        <BrandPageSubBrandsList subBrands={subBrands} />
      </StyledHorizontalList>
      {isNextActive && (
        <NextCircleButton
          onClick={() => next()}
          aria-label={undefined}
          size="sm"
        >
          <Icon
            size="XSS"
            asset={GenericIconName.ArrowRight}
            fill={COLORS.White}
          />
        </NextCircleButton>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  max-width: 100%;
  justify-content: center;
`;

const StyledCircleButton = styled(Button)`
  background: ${COLORS.Grey0};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.08),
    0px 3px 12px 2px rgba(0, 0, 0, 0.07);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid ${COLORS.Grey1};
  justify-content: center;
  align-items: center;
  align-self: center;
  position: absolute;
  z-index: ${Z_INDEXES.LEGACY_FLOATING_ACTION_BUTTOn};
  display: none;

  ${tabletAndUpLinaria('display: flex;')};
`;

const PrevCircleButton = styled(StyledCircleButton)`
  left: 1rem;
`;

const NextCircleButton = styled(StyledCircleButton)`
  right: 1rem;
`;

const StyledHorizontalList = styled(HorizontalList)<{
  $centered?: boolean;
}>`
  height: 40px;

  display: flex;
  justify-content: center;

  ${HorizontalListWrapper} {
    width: 100%;
    gap: ${SLIDER_GAP}px;
    overflow-y: hidden;
    padding: 0 16px;

    &:after {
      ${mobileOnlyLinaria('display: none;')};
    }

    // since the width of this list is 100% on mobile, the following justify-content property
    // is needed to keep the brand tiles centered aligned when they fit the screen width
    justify-content: ${({$centered}) => ($centered ? 'center' : 'flex-start')};

    ${tabletAndUpLinaria(`
      width: auto;
      justify-content: unset;
    `)}
  }
`;
